import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, Copy, X } from "lucide-react";
import { toast } from "sonner";
import { EnterAfterPurchase } from "@/components/EnterAfterPurchase";

const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Pix na própria página: mostra o QR code, o "copia e cola" e libera sozinho quando o pagamento é confirmado. */
export function PixModal({ data, statusUrl, loggedIn, onClose, onPaid, buyerEmail }) {
  const [paid, setPaid] = useState(false);
  const [secs, setSecs] = useState(0);
  const timer = useRef(null);
  useEffect(() => {
    if (!data) return undefined;
    let vivo = true;
    const tick = async () => {
      try { const r = await api.get(statusUrl); if (vivo && r.data.status === "approved") { setPaid(true); onPaid?.(); return; } } catch (e) { /* tenta de novo */ }
      if (vivo) timer.current = setTimeout(tick, 3000);
    };
    timer.current = setTimeout(tick, 3000);
    const c = setInterval(() => setSecs((x) => x + 1), 1000);
    return () => { vivo = false; clearTimeout(timer.current); clearInterval(c); };
  }, [data, statusUrl]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!data) return null;
  const copiar = () => { navigator.clipboard.writeText(data.pix.qr_code); toast.success("Código Pix copiado! Cole no app do seu banco."); };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" data-testid="pix-modal">
      <div className="bg-white rounded-3xl w-full max-w-sm p-6 relative text-center">
        {!paid && <button onClick={onClose} className="absolute top-3 right-3 text-slate-400 hover:text-slate-600" aria-label="Fechar"><X className="h-5 w-5" /></button>}
        {paid ? (
          <div className="py-4 space-y-3" data-testid="pix-paid">
            <CheckCircle2 className="h-16 w-16 text-[#1E9E2A] mx-auto" />
            <h3 className="font-display text-2xl font-bold text-slate-900">Pagamento confirmado!</h3>
            {loggedIn
              ? <p className="text-slate-500">Sua matrícula foi liberada. Bons estudos!</p>
              : <p className="text-slate-500">Sua matrícula está garantida. Agora crie sua senha para entrar na plataforma. A nota fiscal chega por e-mail.</p>}
            {loggedIn
              ? <Button onClick={() => { window.location.assign("/app"); }} className="w-full text-white" style={{ background: "#1E9E2A" }} data-testid="pix-continue">Ir para meus cursos</Button>
              : <EnterAfterPurchase orderId={data?.order_id} email={buyerEmail} />}
          </div>
        ) : (
          <div className="space-y-3">
            <h3 className="font-display text-xl font-bold text-slate-900">Pague com Pix</h3>
            <div className="font-display text-3xl font-bold text-[#1E9E2A]">{brl(data.pix.amount)}</div>
            {data.pix.qr_image ? <img src={data.pix.qr_image} alt="QR code do Pix" className="mx-auto w-56 h-56 rounded-xl border border-slate-200" data-testid="pix-qr" /> : <div className="mx-auto w-56 h-56 grid place-items-center rounded-xl border border-slate-200 text-slate-400 text-sm">Use o código abaixo</div>}
            <Button variant="outline" onClick={copiar} className="w-full" data-testid="pix-copy"><Copy className="h-4 w-4 mr-1.5" /> Copiar código Pix (copia e cola)</Button>
            <ol className="text-xs text-slate-500 text-left list-decimal pl-5 space-y-0.5">
              <li>Abra o app do seu banco e escolha Pix.</li>
              <li>Leia o QR code ou use o "Pix copia e cola".</li>
              <li>Confirme o valor. Esta tela libera sozinha quando o pagamento chegar.</li>
            </ol>
            <div className="flex items-center justify-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Aguardando o pagamento… <span className="text-xs text-slate-400">{Math.floor(secs / 60)}:{String(secs % 60).padStart(2, "0")}</span></div>
          </div>
        )}
      </div>
    </div>
  );
}
